import Meet from "../components/meetingrequest/index";
import Layout from "../components/layouts/allpagelayout";

export default function MeetingRequestPage() {
  return (
    <Layout>
      <div className="max-w-7xl mx-auto px-4 ">
       
            <Meet />
        </div>
       
   
    </Layout>
  );
}